export default __webpack_public_path__ + "static/media/side.1d878243.png";